import { fetchYouTubeSubtitles } from "@husky-hrc/Framework/Services/YouTubeCaptionService";

const parseTranscript = (events: any[]) => {
    const captionLines = events.map(({ tStartMs, dDurationMs, segs: [{ utf8 }] }) => ({
        start: formatTime(tStartMs),
        dur: formatTime(dDurationMs),
        text: utf8,
    }));

    return captionLines;
};

const formatTime = (milliseconds: any) => {
    const date = new Date(milliseconds);
    return date.toUTCString().substr(17, 8);
};

export const getTranscript = async (videoId: string, language?: string) => {
    const transcript = await fetchYouTubeSubtitles(videoId, { languageId: language });
    if (transcript.length === 0) {
        return [] as any;
    }
    const jsonTranscript = parseTranscript(transcript);
    return jsonTranscript || [];
};
